<header class="header">
  @let logoConfig = logoConfig$ | async;
  <div class="header__logo">
    <a class="logo" [routerLink]="settings.logoLink">
      <img
        class="logo-image"
        alt="{{ profile.organization_name }} Logo - Homepage"
        [ngClass]="{ 'is-circle': logoConfig.logoFormType === CROPPER_MODES.CIRCLE }"
        [src]="logoConfig.imageConfig.imageFile"
      />
    </a>
  </div>

  <div class="header__main-menu">
    @for (menuItem of settings.mainMenu; track i; let i = $index) {
      @if (menuItem.dropdownMenu) {
        <cm-dropdown-menu [menuItem]="menuItem" [isLast]="i === settings.mainMenu.length - 1" />
      }
      @if (!menuItem.dropdownMenu) {
        <a
          [routerLink]="menuItem.externalLink ? null : menuItem.link"
          [routerLinkActive]="menuItem.externalLink ? '' : 'header__link--active'"
          class="header__link"
          (click)="onRouterLinkClick(menuItem)"
        >
          @if (menuItem.icon) {
            <cm-icon [name]="menuItem.icon" class="header__icon" />
          }
          {{ menuItem.label }}
        </a>
      }
    }

    @if (isProfileLinkVisible) {
      <a
        class="header__link header__link--profile"
        [routerLink]="profileDetailsLink$ | async"
        routerLinkActive="header__link--active"
        aria-label="Profile Details"
      >
        <cm-active-profile class="active-profile" [profile]="profile" />
      </a>
    } @else {
      <cm-active-profile class="active-profile" [profile]="profile" />
    }

    <div class="header__item log-out">
      <button
        type="button"
        class="log-out__btn"
        (click)="onLogout()"
        data-id="logout-btn"
        ngbTooltip="Log out"
        placement="bottom"
        container="body"
      >
        <img alt="Log out" class="log-out__img" src="/assets/images/log-out.svg" />
      </button>
    </div>

    <div class="header__item show-mobile">
      <button
        class="mobile-menu-btn"
        (click)="onToggleMobileMenu()"
        [attr.aria-label]="showMobileMenu ? 'Close Menu' : 'Open Menu'"
      >
        <cm-hamburger-icon [class.open]="showMobileMenu" />
      </button>
    </div>
  </div>
</header>
@if (showMobileMenu) {
  <cm-mobile-menu
    class="mobile-menu"
    [items]="settings.mainMenu"
    [profile]="profile"
    [profiles]="profiles"
    (logout)="onLogout()"
    (closeMobileMenu)="closeMobileMenu($event)"
  />
}
